import { createReducer, on } from '@ngrx/store';
import { VendorPaymentEntity } from '@resident-select/domain/vendor-payment';
import { BookingEntity } from '@resident-select/domain/booking';
import {
  CreatedVendorPaymentEvent,
  GotAllBookingsByVendorAndStatusEvent,
  GotAllVendorPaymentByVendorIdEvent,
  GotBookingsByVendorPaymentIdByDateRangeEvent,
} from './vendor-payment.events';
import { VendorPaymentState } from './vendor-payment.state';

export const vendorPaymentKey = 'vendorPayment';
export const initialState: VendorPaymentState = {
  entities: {},
  byQuery: {},
  bookings: {},
  filteredBookings: {},
};

export const VendorPaymentReducer = createReducer(
  initialState,
  on(GotAllVendorPaymentByVendorIdEvent, (state, { entities }) => ({
    ...state,
    entities: entities.reduce((acc, entity) => ({ ...acc, [entity.id]: entity }), {}),
  })),
  on(CreatedVendorPaymentEvent, (state, action: any) => {
    const newEntities = (action.entities || []) as VendorPaymentEntity[];
    return {
      ...state,
      entities: {
        ...state.entities,
        ...newEntities.reduce(
          (acc: any, entity: VendorPaymentEntity) => ({ ...acc, [entity.id]: entity }),
          {},
        ),
      },
    };
  }),
  on(GotAllBookingsByVendorAndStatusEvent, (state, action: any) => {
    const bookings = (action.entities || []) as BookingEntity[];
    return {
      ...state,
      bookings: bookings.reduce(
        (acc: any, entity: BookingEntity) => ({ ...acc, [entity.id]: entity }),
        {},
      ),
    };
  }),
  on(GotBookingsByVendorPaymentIdByDateRangeEvent, (state, action: any) => {
    const bookings = (action.entities || []) as BookingEntity[];
    return {
      ...state,
      filteredBookings: bookings.reduce(
        (acc: any, entity: BookingEntity) => ({ ...acc, [entity.id]: entity }),
        {},
      ),
    };
  }),
);
